/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgDataMeasure = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M2 3a1 1 0 0 1 1-1h6.001A3.99 3.99 0 0 1 12 3.354 3.99 3.99 0 0 1 14.999 2H21a1 1 0 0 1 1 1v9.03l-2-.2V4h-5.001A2 2 0 0 0 13 5.999v15a1 1 0 1 1-2 0c0-1.106-.894-2-2-2H3a1 1 0 0 1-1-1zm9 14.534V5.999A2 2 0 0 0 9.001 4H4v12.999h5c.729 0 1.412.195 2 .535z" />
        <path d="m17.605 13.9-.21 2.1H15v2h2.195l-.1 1H15v2h1.895l-.19 1.9 1.99.2.21-2.1h.99l-.19 1.9 1.99.2.21-2.1H24v-2h-1.895l.1-1H24v-2h-1.595l.19-1.9-1.99-.2-.21 2.1h-.99l.19-1.9zm1.5 5.1.1-1h.99l-.1 1z" />
      </g>
    </g>
  </Icon>
);
export { SvgDataMeasure as DataMeasure };
